export class ActionTypeModel{
  
    ticketGroupId:string
    description:string;
    ticketTypeNameList:Array<ActionTypeModelName>=[];

}
export class ActionTypeModelName{
    ticketTypeName:string;
    ticketTypeId:string;

}

